import { esGuaranies } from '../../utils/format'

function Field({ label, required, span = 3, children }) {
  return (
    <div className={'field col-' + span}>
      <label className="field-label">{label}{required && <span className="req">*</span>}</label>
      {children}
    </div>
  )
}
function Select({ value, onChange, children, error }) {
  return (
    <div className="field-input-wrap combobox">
      <select className="field-input" style={{ appearance: 'none', WebkitAppearance: 'none', borderColor: error ? 'var(--danger)' : undefined }}
        value={value} onChange={onChange}>
        {children}
      </select>
    </div>
  )
}
const byId = (list, v) => list.find((o) => String(o.id) === String(v)) || null

// ② Detalles del comprobante — grilla de campos del diseño (sin Cliente, que es la card ①).
export default function CabeceraForm({ vm, submitted }) {
  const { comprobante, setField, sucursalesCliente, monedas, tipos, listasPreciosVentas, almacenes } = vm
  const cotizacionRequerida = comprobante.moneda && !esGuaranies(comprobante.moneda)

  return (
    <div className="form-grid">
      <Field label="Tipo de comprobante" required span={3}>
        <Select value={comprobante.tipo?.id ?? ''} error={submitted && !comprobante.tipo}
          onChange={(e) => setField('tipo', byId(tipos, e.target.value))}>
          <option value="">—</option>
          {tipos.map((t) => <option key={t.id} value={t.id}>{t.descripcion}</option>)}
        </Select>
      </Field>

      <Field label="Fecha" required span={2}>
        <input className="field-input" type="date" value={comprobante.fecha || ''}
          onChange={(e) => setField('fecha', e.target.value)}
          style={{ borderColor: submitted && !comprobante.fecha ? 'var(--danger)' : undefined }} />
      </Field>

      <Field label="Sucursal del cliente" required span={3}>
        <Select value={comprobante.sucursalCliente?.id ?? ''} error={submitted && !comprobante.sucursalCliente}
          onChange={(e) => setField('sucursalCliente', byId(sucursalesCliente, e.target.value))}>
          <option value="">—</option>
          {sucursalesCliente.map((s) => <option key={s.id} value={s.id}>{s.codigoSucursal} · {s.descripcion}</option>)}
        </Select>
      </Field>

      <Field label="Almacén / Depósito" required span={4}>
        <Select value={comprobante.deposito?.id ?? ''} error={submitted && !comprobante.deposito}
          onChange={(e) => setField('deposito', byId(almacenes, e.target.value))}>
          <option value="">—</option>
          {almacenes.map((a) => <option key={a.id} value={a.id}>{a.descripcion}</option>)}
        </Select>
      </Field>

      <Field label="Moneda" required span={2}>
        <Select value={comprobante.moneda?.id ?? ''} error={submitted && !comprobante.moneda}
          onChange={(e) => setField('moneda', byId(monedas, e.target.value))}>
          {monedas.map((m) => <option key={m.id} value={m.id}>{m.descripcion}</option>)}
        </Select>
      </Field>

      <Field label="Tipo de cambio" span={2}>
        <input className="field-input mono" type="number" value={comprobante.cambio ?? ''} disabled={!cotizacionRequerida}
          onChange={(e) => setField('cambio', e.target.value)} style={{ textAlign: 'right', background: cotizacionRequerida ? '#fff' : 'var(--bg)' }} />
      </Field>

      <Field label="Lista de precios" span={4}>
        <Select value={comprobante.listaPrecioVenta?.id ?? ''}
          onChange={(e) => setField('listaPrecioVenta', byId(listasPreciosVentas, e.target.value))}>
          <option value="">— Sin lista —</option>
          {listasPreciosVentas.map((l) => <option key={l.id} value={l.id}>{l.descripcion}</option>)}
        </Select>
      </Field>

      <div className="col-12">
        <div className="checkrow">
          <label className="check"><input type="checkbox" checked={comprobante.imputarIvaGeneral} onChange={(e) => setField('imputarIvaGeneral', e.target.checked)} /> IVA general</label>
          <label className="check"><input type="checkbox" checked={comprobante.imputarIre} onChange={(e) => setField('imputarIre', e.target.checked)} /> Imputa IRE</label>
          <label className="check"><input type="checkbox" checked={comprobante.imputarIrpRsp} onChange={(e) => setField('imputarIrpRsp', e.target.checked)} /> Imputa IRP / RSP</label>
        </div>
      </div>
    </div>
  )
}
